/**
 * Quanto un'azienda usa Prospero, per il back office: si contano i giorni con
 * almeno una registrazione (autocontrolli, ricezione merci, lotti, ...) negli
 * ultimi TENANT_ACTIVITY_WINDOW_DAYS giorni. I login non contano.
 */
export const TENANT_ACTIVITY_LEVELS = ['ACTIVE', 'LOW', 'INACTIVE'] as const;

export type TenantActivityLevel = (typeof TENANT_ACTIVITY_LEVELS)[number];

/** Finestra, in giorni di calendario Europe/Rome compreso oggi. */
export const TENANT_ACTIVITY_WINDOW_DAYS = 30;

/** Giorni attivi nella finestra da cui un'azienda e' "Attiva": circa due a settimana. */
export const TENANT_ACTIVITY_ACTIVE_MIN_DAYS = 8;

export function resolveTenantActivityLevel(activeDays: number): TenantActivityLevel {
  if (activeDays >= TENANT_ACTIVITY_ACTIVE_MIN_DAYS) {
    return 'ACTIVE';
  }
  return activeDays > 0 ? 'LOW' : 'INACTIVE';
}
